import { schema } from 'normalizr';
import activityCategoryType from './activityCategoryType';

const activityCategory = new schema.Entity('activityCategories', {
  types: [activityCategoryType],
});

export default activityCategory;
